/**
 * Auto-growing textarea for the BO write-back note. The wrapping
 * `<div>` captures click analytics; the inner `<textarea>` captures
 * change analytics. Height management is owned by `useAutoGrowTextarea`.
 *
 * @module busniessOffice/components/singleComment/WriteBackTextarea
 */

import React from "react";

interface WriteBackTextareaProps {
  id: string;
  value: string;
  onChange: (value: string) => void;
  onContainerClick: () => void;
  textareaRef: React.RefObject<HTMLTextAreaElement>;
}

const WriteBackTextarea = ({
  id,
  value,
  onChange,
  onContainerClick,
  textareaRef,
}: WriteBackTextareaProps) => {
  const fieldId = `write-back-note-${id}`;
  return (
    <div className="write-back-note h-max p-3" onClick={onContainerClick}>
      <textarea
        ref={textareaRef}
        className="w-full resize-none overflow-hidden text-h12 font-normal outline-none"
        value={value}
        name={fieldId}
        id={fieldId}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
};

export default WriteBackTextarea;
